import { gql } from '@apollo/client';
import { nodeDataFragment, nodeResourceFragment } from './nodes';

export const tileMetricsFragment = gql`
  fragment TileMetricsFragment on TileMetrics {
    sendEmailAction {
      metricName
      metricNiceName
      category
      valueType
    }
    sendSMSAction {
      metricName
      metricNiceName
      category
      valueType
    }
    sendPushAction {
      metricName
      metricNiceName
      category
      valueType
    }
    sendWebPushAction {
      metricName
      metricNiceName
      category
      valueType
    }
    sendInAppAction {
      metricName
      metricNiceName
      category
      valueType
    }
  }
`;
export const workflowFragment = gql`
  fragment WorkflowFragment on Workflow {
    id
    createdAt
    description
    enabled
    name
    labels {
      id
      name
    }
    goals {
      id
      isActive
      createdAt
      updatedAt
      conversions {
        eventName
        attributionMode
        attributionPeriodHours
      }
    }
    projectId
    startWorkflowNodeId
    triggerEventNames
    workflowType
    updatedAt
    workflowLifetimeLimit
    visitorTrackingEnabled
    workflowReference {
      workflowType
      id
      visitorTrackingEnabled
    }
    workflowSimultaneousLimit
    workflowConcurrentJourneyEntranceCriteria {
      journeys
    }
    nodes: allNodes {
      id
      liveWorkflowNodeId
      x
      y
      title
      resourceName
      resource {
        ...NodeResourceFragment
      }
      nodeData {
        ...NodeDataFragment
      }
      nodeDataJson
      description
    }
    notes: allNotes {
      id
      createdAt
      updatedAt
      createdBy
      updatedBy
      x
      y
      title
      body
    }
    edges {
      srcWorkflowNodeId
      destWorkflowNodeId
      srcWorkflowNodeOutputIndex
    }
    tileMetrics {
      ...TileMetricsFragment
    }
  }
  ${tileMetricsFragment}
  ${nodeResourceFragment}
  ${nodeDataFragment}
`;

export const clonedFromJourneyFragment = gql`
  fragment ClonedFromJourneyFragment on Workflow {
    clonedFromJourney {
      projectId
      workflowType
      name
      id
      status
    }
    nodes: allNodes {
      id
      clonedFromNode {
        resource {
          ... on CampaignNodeResource {
            campaign {
              conversions {
                __typename
              }
            }
          }
          ... on MultiCampaignNodeResource {
            resources {
              campaign {
                conversions {
                  __typename
                }
              }
            }
          }
        }
        nodeDataJson
        nodeData {
          ... on DelayAction {
            delayUsingProperty {
              dataType
            }
          }
        }
      }
    }
  }
`;

export const tilesetDataFragment = gql`
  fragment TilesetDataFragment on WorkflowFragmentData {
    nodes {
      x
      y
      id
      title
      description
      nodeData
    }
    edges {
      srcWorkflowNodeId
      destWorkflowNodeId
      srcWorkflowNodeOutputIndex
    }
    notes {
      x
      y
      title
      body
    }
  }
`;
